<template>
  <InvoiceDetailTabDetail
    v-if="activeTab === 'detail'"
    :invoice="invoice"
    :issuer="issuer"
    :selected-receiver="selectedReceiver"
    :invoice-info="invoiceInfo"
    :payment-method-label="paymentMethodLabel"
    :payment-form-label="paymentFormLabel"
    :concepts="concepts"
    :comments="comments"
    :currency="currency"
    :subtotal="subtotal"
    :discount-amount="discountAmount"
    :transferred-tax-amount="transferredTaxAmount"
    :withheld-tax-amount="withheldTaxAmount"
    :total="total"
    :invoice-operation="invoiceOperation"
    @pay-invoice="$emit('pay-invoice')"
  />

  <InvoiceDetailTabShipping
    v-else-if="activeTab === 'shipping'"
    :invoice="invoice"
    :refresh-tick="shippingRefreshTick"
  />
  <InvoiceDetailTabDocuments v-else-if="activeTab === 'documents'" :invoice="invoice" />
  <InvoiceDetailTabHistory v-else-if="activeTab === 'history'" :invoice="invoice" />

  <InvoiceDetailTabDetail
    v-else
    :invoice="invoice"
    :issuer="issuer"
    :selected-receiver="selectedReceiver"
    :invoice-info="invoiceInfo"
    :payment-method-label="paymentMethodLabel"
    :payment-form-label="paymentFormLabel"
    :concepts="concepts"
    :comments="comments"
    :currency="currency"
    :subtotal="subtotal"
    :discount-amount="discountAmount"
    :transferred-tax-amount="transferredTaxAmount"
    :withheld-tax-amount="withheldTaxAmount"
    :total="total"
    :invoice-operation="invoiceOperation"
    @pay-invoice="$emit('pay-invoice')"
  />
</template>

<script>
import InvoiceDetailTabDetail from '@/components/invoices/detail/tabs/InvoiceDetailTabDetail.vue';
import InvoiceDetailTabShipping from '@/components/invoices/detail/tabs/InvoiceDetailTabShipping.vue';
import InvoiceDetailTabDocuments from '@/components/invoices/detail/tabs/InvoiceDetailTabDocuments.vue';
import InvoiceDetailTabHistory from '@/components/invoices/detail/tabs/InvoiceDetailTabHistory.vue';

export default {
  name: 'InvoiceDetailTabsPanel',
  components: {
    InvoiceDetailTabDetail,
    InvoiceDetailTabShipping,
    InvoiceDetailTabDocuments,
    InvoiceDetailTabHistory,
  },
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    issuer: {
      type: Object,
      default: () => ({}),
    },
    selectedReceiver: {
      type: Object,
      default: null,
    },
    invoiceInfo: {
      type: Object,
      default: () => ({}),
    },
    paymentMethodLabel: {
      type: String,
      default: '',
    },
    paymentFormLabel: {
      type: String,
      default: '',
    },
    concepts: {
      type: Array,
      default: () => [],
    },
    comments: {
      type: String,
      default: '',
    },
    currency: {
      type: String,
      default: 'MXN',
    },
    subtotal: {
      type: Number,
      default: 0,
    },
    discountAmount: {
      type: Number,
      default: 0,
    },
    transferredTaxAmount: {
      type: Number,
      default: 0,
    },
    withheldTaxAmount: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    invoiceOperation: {
      type: Object,
      default: () => ({}),
    },
    invoice: {
      type: Object,
      default: null,
    },
    shippingRefreshTick: {
      type: Number,
      default: 0,
    },
  },
  emits: ['pay-invoice'],
};
</script>
